/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { CallControlsVehicleFragmentDoc } from '../../../../../ad-operator-call/src/lib/components/CallControls/CallControls.hook'
import { AdPoolingToggleVehicleFragmentDoc } from '../../../../../ad-pooling-toggle/src/lib/AdPoolingToggle.hook'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { AdVehicleStreamHubReturnVehicleFragmentDoc } from '../../HubReturn/graphql/HubReturnVehicle.hook'
export type AdVehicleStreamHeaderVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isSelfDriving: boolean
  label: number | null
  isResponsive: boolean | null
  fccOperatorAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
    }>
  } | null
  pooling: { __typename?: 'Pooling'; enabled: boolean } | null
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
    }>
  } | null
  fleet: { __typename?: 'Fleet'; id: string } | null
  region: { __typename?: 'Region'; id: string } | null
  latestADTelemetry: {
    __typename?: 'ADTelemetry'
    sdsMode: {
      __typename?: 'SDSModeWithTimestamp'
      sdsMode: Types.SdsMode
    } | null
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          trip: { __typename?: 'Trip'; id: string } | null
        }
      | { __typename: 'FccWaypointHubReturnAction'; id: string }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          trip: { __typename?: 'Trip'; id: string } | null
        }
      | { __typename: 'FccWaypointReallocationAction' }
    >
  }> | null
}

export const AdVehicleStreamHeaderVehicleFragmentDoc = gql`
    fragment AdVehicleStreamHeaderVehicle on Vehicle {
  id
  isSelfDriving
  label
  fccOperatorAdAlerts {
    alerts {
      __typename
      id
      type
    }
  }
  ...AdPoolingToggleVehicle
  ...CallControlsVehicle
  ...AdVehicleStreamHubReturnVehicle
}
    ${AdPoolingToggleVehicleFragmentDoc}
${CallControlsVehicleFragmentDoc}
${AdVehicleStreamHubReturnVehicleFragmentDoc}`
